
import Vue from 'vue';
import Api from '../../base/script/api';
import catalogFilter from '../filter/filter';
import card from '../card/card';
import PopupCards from '../popup/cards/popup-cards';
import Sorting from '../sorting/sorting';
import PopupFullscreen from '../popup/fullscreen/popup-fullscreen';
import AnimationFade from '../../core/animation/fade/animation-fade';
import PopupVideo from '../popup/video/popup-video';

export default function () {
  const catalog = document.querySelector('.catalog');

  if (catalog) {
    new Vue({
      el: catalog,
      delimiters: ['${', '}}'],
      data: {
        tmpCards: [],
        virtualPage: 1,
        page: 1,
        count: 0,
        maxPages: null,
        maxVisibleCards: 15,
        filter: null,
        manager: window.manager,
        popupIsOpen: false,
        clickedIndex: null,
        popupFullOpen: false,
        popupVideoOpen: false,
        popupVideoData: '',
        fullscreenCards: null,
        fullscreenActive: 0,
        activeSortOption: null,
        isMobile: window.innerWidth < 1280,
        options: window.sortOptions || [
          {
            name: 'effective',
            text: 'по популярности',
            value: 'order_effective_position',
            checked: true,
          },
          {
            name: 'position',
            text: 'по актуальности',
            value: 'order_position_actual',
          },
          {
            name: 'area-desc',
            text: 'по площади',
            mobileText: 'сначала больше',
            value: 'order_area',
          },
          {
            name: 'area-asc',
            value: 'order_area_asc',
            mobileText: 'сначала меньше',
          },
          {
            name: 'price-desc',
            text: 'по цене',
            mobileText: 'сначала дороже',
            value: 'order_price',
          },
          {
            name: 'price-asc',
            mobileText: 'сначала дешевле',
            value: 'order_price_asc',
          },
        ],
      },
      components: {
        catalogFilter,
        card,
        PopupCards,
        Sorting,
        AnimationFade,
        PopupFullscreen,
        PopupVideo,
      },
      watch: {
        virtualPage(newValue) {
          if (this.tmpCards.length < this.maxVisibleCards * (newValue + 1)) {
            if (this.page < this.maxPages) {
              this.page += 1;
              if (this.filter) {
                this.filter.page = this.page;
              }
              this.loadCards(this.filter ? this.filter : false);
            }
          }
        },
        popupFullOpen(newValue) {
          if (!newValue) {
            const popup = this.$el.querySelector('.popup-cards');
            window.bodyLock.disableBodyScroll(popup);
          }
        },
      },
      computed: {
        showBtn() {
          if (!this.tmpCards) {
            return false;
          }
          if (this.maxVisibleCards * this.virtualPage < this.tmpCards.length) {
            return true;
          }
          return this.page < this.maxPages;
        },
        cards() {
          if (!this.tmpCards) {
            return false;
          }
          return this.tmpCards.slice(0, this.maxVisibleCards * this.virtualPage);
        },
      },
      methods: {
        submitSorting(e) {
          this.activeSortOption = e.target.value;
          this.submitFilter(this.filter);
        },
        submitFilter(filterData) {
          if (this.activeSortOption) {
            if (filterData) {
              this.filter = Object.assign(filterData, { order_field: this.activeSortOption });
            } else {
              this.filter = { order_field: this.activeSortOption };
            }
          } else {
            this.filter = filterData;
          }
          this.page = 1;
          this.filter.page = 1;
          this.virtualPage = 1;
          this.loadCards(this.filter, false);
        },
        visibleCardsCount() {
          if (window.innerWidth <= 767) {
            this.maxVisibleCards = 5;
          } else if (window.innerWidth >= 768 && window.innerWidth <= 1279) {
            this.maxVisibleCards = 10;
          } else {
            this.maxVisibleCards = 15;
            if (catalog.classList.contains('catalog--new')) {
              this.maxVisibleCards = 9;
            }
          }
        },
        loadCards(filterData, nextPage = true) {
          const data = filterData !== false ? filterData : { page: this.page };
          const testingFilter = window.location.search ? window.location.search : '';
          if (testingFilter && testingFilter.length > 0) {
            const tf = new URLSearchParams(testingFilter);
            if (tf.has('testing_filter')) {
              data.testing_filter = tf.get('testing_filter');
            }
          }
          Api.post(this.action, data)
            .then((response) => {
              if (nextPage) {
                response.data.cards.forEach((item) => {
                  this.tmpCards.push(item);
                });
              } else {
                this.tmpCards = response.data.cards;
                this.virtualPage = 1;
                this.maxPages = response.data.maxPages;
                this.page = 1;
              }
              this.count = response.data.count;
            });
        },
        nextPage() {
          this.virtualPage += 1;
        },
        OpenPopup(index) {
          this.clickedIndex = index;
          const popup = this.$el.querySelector('.popup-cards');
          window.bodyLock.disableBodyScroll(popup);
          setTimeout(() => {
            this.popupIsOpen = true;
          }, 500);
        },
        openFullscreen(data) {
          this.fullscreenCards = data.cards;
          this.fullscreenActive = data.active;
          this.popupFullOpen = true;
        },
        openVideo(data) {
          setTimeout(() => {
            this.popupVideoOpen = true;
            if (data) {
              this.popupVideoData = data;
            }
          }, 500);
        },
      },
      mounted() {
        this.visibleCardsCount();
        window.addEventListener('resize', () => {
          this.visibleCardsCount();
          this.isMobile = window.innerWidth < 1280;
        });
        this.loadCards(false, false);
        this.isMobile = window.innerWidth < 1280;
      },
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/catalog/catalog.js